import { createElement } from 'react';
import { lang } from '../../../Utils';
import icons from './Icons';
import Switch from './Switch';

const Item = ({target, countries, country, uuid, group, title, icon, content, link, isEdit, currentGroup, handleCheck, value }) => {
  const Component = icons[icon.toLowerCase()];
  
  if ((!!country && !!countries && (countries.indexOf(country.toLowerCase()) < 0))) {
    return null;
  } else if (isEdit && currentGroup !== 'all' && currentGroup !== group) {
    return null;
  } else {
    return <div className="my-homepage-item">
      {(isEdit) ? <Switch handleCheck={handleCheck} uuid={uuid} value={value}/> : null}
      <div className="my-homepage-icon">
        {(icon && icon !== '') ? createElement(Component) : null}
      </div>
      <div className="my-homepage-body">
        <div className="my-homepage-title">
          {title}
        </div>
        <div className="my-homepage-content">
          {content}
        </div>
        <div className="my-homepage-link">
          <a href={link} without rel="noreferrer" target={(!!target && target==="1") ? '_blank' : '_self'}>{lang('Go to')} {title}</a>
        </div>
      </div>
    </div>
  }

}

export default Item;